import { usePointCloudContext, ViewerMode } from 'features/pointClouds'
import { BottomOverlayMenuButton } from 'features/siteView'
import { PlusIcon } from 'lucide-react'
import React, { FC } from 'react'
import styled from 'styled-components'

const StyledPlusIcon = styled(PlusIcon)`
  width: 32px;
  height: 32px;
  margin-left: -4px;
`

interface AddObservationButtonProps {
  closeMenu?: () => void
}

export const AddObservationButton: FC<AddObservationButtonProps> = (props) => {
  const { setViewerMode } = usePointCloudContext()

  const handleClick = () => {
    if (props.closeMenu) {
      props.closeMenu()
    }
    setViewerMode(ViewerMode.SELECTION)
  }

  return (
    <BottomOverlayMenuButton onClick={handleClick}>
      <StyledPlusIcon />
      Add Observation (R)
    </BottomOverlayMenuButton>
  )
}
